import { Messages } from '~src/codegen/Localize';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import React = require('react');


export interface KbArticleLinkProps {
    pageId: string;
}

const tableauKnowledgeBaseUrl = 'https://kb.tableau.com';

function buildKbArticleUrl(pageId: string): string {
    const lang = getSessionManagementServiceInstance().sessionLanguage();
    const langQuery = lang ? '?lang=' + lang : '';
    return tableauKnowledgeBaseUrl + '/articles/Issue/' + pageId + langQuery;
}

export function KbArticleLink(props: KbArticleLinkProps) {
    if (!props.pageId) {
        return null;
    }

    return <a href={buildKbArticleUrl(props.pageId)}>
        {Messages.knowledgeBase()}
    </a>;
}